import styled from 'styled-components';
import { Button, Form } from 'shared/components';
import { Link } from 'react-router-dom';
import { Layout } from 'antd';

import { color } from 'shared/utils/styles';

export const StyledLayout = styled(Layout)`
  min-height: 100vh;
  justify-content: center;
  background-color: ${color.primary};

  .ant-tabs-top > .ant-tabs-nav {
    margin: 0;
  }

  .ant-tabs-card.ant-tabs-top > .ant-tabs-nav .ant-tabs-tab-active {
    background-color: #fff;
  }

  .ant-tabs-card > .ant-tabs-nav .ant-tabs-tab {
    background-color: #dedede;
  }

  .ant-tabs-card > .ant-tabs-nav .ant-tabs-tab {
    padding: 16px 63px;
  }

  .ant-tabs-card > .ant-tabs-nav .ant-tabs-tab:first-child {
    margin-right: 2px;
  }

  form {
    // border-radius: 0;
  }
`;

export const Heading = styled.div`
  display: flex;
  justify-content: center;
`;

export const FormHeading = styled.div`
  font-size: 21px;
  font-weight: bold;
`;

export const FormSecondHeading = styled.a`
  font-size: 21px;
  font-weight: bold;
  color: #1f4370;
`;

export const FormElement = styled(Form.Element)`
  padding: 16px 20px 30px;
  width: 400px;
  // height: 400px;
  margin: 0 auto;
  background: #fff;
  border-radius: 10px;
`;

export const Actions = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 20px;
`;

export const ActionButton = styled(Button)`
  width: 100%;
  color: #fff;
  font-weight: bold;
`;

export const LoginPage = styled.div`
  background-color: ${color.primary};
  height: 100vh;
  display: flex;
  align-items: center;
`;

export const Tip = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
  font-size: 12px;
`;

export const SmallTip = styled.div`
  a {
    margin-left: 5px;
  }
`;

export const LinkItem = styled(Link)`
  color: #1f4370;
  font-weight: bold;
  &:active {
    color: #1f4370;
  }
`;
export const Error = styled.div`
  margin-top: 5px;
  color: #8a0303;
  font-size: 12px;
  text-align: center;
`;
